import React from 'react';
import { FormControlLabel, Switch } from '@mui/material';

export const CustomInputSwitch = (props) => {

    const { label, onChange, value, disabled } = props;

    return (
        <div style={{ display: 'flex', flexFlow: 'column noWrap', gap: 5, marginBottom: 15 }}>
            <label style={{ fontWeight: 600, fontSize: 14 }} htmlFor="switch">{ label }</label>
            <FormControlLabel control={<Switch checked={ value } onChange={ onChange } />} disabled={ disabled } />
        </div>
    )
}

CustomInputSwitch.defaultProps = {
    label: '',
    onChange: () => false,
    value: false,
    disabled: false
}